import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from '../ProfileV2/shared/Modal';
import Fetch from '@components/util/Fetch';
import { formatPhoneNumber } from '../util/textMasks';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import Icons from '@components/shared/icons';
import './title-modal-styles.scss';

const TitleModal = (props) => {
  const {
    afterSubmit = () => {},
    close,
    hideCloseButton = false,
    isOpen,
    matchId,
    phoneNumber,
    servicesSubmitted,
    textConsent,
  } = props;

  const [consentGiven, setConsentGiven] = useState(textConsent);
  const [matchTitleCompleted, setMatchTitleCompleted] = useState(false);

  useEffect(() => {
    if (!textConsent && isOpen) {
      logCrmEvent('disruptor_viewed', { type: 'title_services' });
    }
  }, [isOpen]);

  const submit = async (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const button = e?.currentTarget;
    if (button) button.disabled = true;

    try {
      const resp = await Fetch.post({
        url: '/title/accept',
        payload: {
          terms_agree: true,
          match_id: matchId,
        },
      });

      if (resp.error) {
        if (window.updateNotice) {
          window.updateNotice(
            {
              header: 'Error!',
              message: resp.error,
            },
            5000,
          );
        }
      } else {
        setConsentGiven(true);
        setMatchTitleCompleted(true);
        afterSubmit();
        close();
      }
    } catch (err) {
      if (window.updateNotice) {
        window.updateNotice(
          {
            header: 'Error!',
            message: err.message,
          },
          5000,
        );
      }
    } finally {
      if (button) button.disabled = false;
    }
  };

  useEffect(() => {
    if (servicesSubmitted) {
      return;
    }

    if (consentGiven && !matchTitleCompleted && isOpen) {
      submit();
    }
  }, [isOpen]);

  const dismiss = (e) => {
    close(e);

    if (!consentGiven) {
      logCrmEvent('disruptor_dismissed', { type: 'title_services' });
    }
  };

  const reject = (e) => {
    close(e);

    logCrmEvent('disruptor_rejected', { type: 'title_services' });
  };

  const content = () => (
    <div className="title-service-inner">
      <h3 className="headline-3 center-align">
        Learn more about how ReferralExchange
        Settlement Services can help you and your clients.
      </h3>
      <label className="phone-input margin-bottom-8">
        Your Phone Number:&nbsp;
        <span className="large-slim-font">
          {formatPhoneNumber(phoneNumber)}
        </span>
      </label>
      <p className="large-slim-font">
        ReferralExchange Settlement Services Inc. provides unparalleled
        title services, ensuring smooth and secure property transactions
        for our clients.  We can help you provide fantastic service to
        your clients during the closing process!
      </p>
      <p className="large-slim-font margin-bottom-16">
        By clicking &quot;Accept&quot; below, I agree to receive automated marketing
        calls and texts from or on behalf of ReferralExchange Settlement
        Services at the phone number provided above. Consent is not a
        condition of any purchase, and may be revoked at any time by replying
        STOP to any text or calling (941) 302-2977. Message and data rates
        may apply; message frequency varies.
      </p>
      <div className="button-container">
        <button
          type="button"
          className="profile-edit-button highlighted"
          onClick={reject}
        >
          No thanks
        </button>
        <button
          type="button"
          className="profile-edit-button submit"
          onClick={submit}
        >
          Accept
        </button>
      </div>
    </div>
  );

  return (
    <Modal
      close={dismiss}
      id="title-modal"
      status={isOpen ? 'active' : 'hidden'}
    >
      <div className="title-service-modal">
        <div className="close-bar">
          {
            !hideCloseButton && (
              <button
                type="button"
                onClick={dismiss}
              >
                <Icons type="close" width={16} height={16} />
              </button>
            )
          }
        </div>
        {content()}
      </div>
    </Modal>
  );
};

export default TitleModal;

TitleModal.propTypes = {
  close: PropTypes.func,
  isOpen: PropTypes.bool,
  textConsent: PropTypes.bool,
  phoneNumber: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  isSeller: PropTypes.bool,
  matchId: PropTypes.number,
  servicesSubmitted: PropTypes.bool,
};
